import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import SignUp from '../pages/SingUp';
import Home from '../pages/Home';

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={SignUp} />
    <Route path="/Home" isPrivate component={Home} />
  </Switch>
);

export default Routes;
